import React from 'react';

import { FilePond } from 'react-filepond';

import {
  Col,

} from 'reactstrap';
import { base_url } from '../../api/common';



class DataUploader extends React.Component {

  constructor(props) {
    super(props);

    this.state = {};
  }


  render() {

    return (
      <Col>

        <FilePond credits={false} server={
          {
            credits: false,
            url: base_url,
            load: (source) => {

              console.log('attempting to load', source); // not working
            },
            process: {
              url: this.props.upload_url,
              method: 'POST',
              withCredentials: false,
              headers: {
                Authorization: localStorage.getItem('token'),
              },
              timeout: 700000,
              onload: this.props.onload,
              onerror: this.props.onerror,
              ondata: (fd) => {
                this.props.start_sending_data();
                return fd;
              },
            },
            revert: {
              url: '/attachment/delete',
              withCredentials: false,
              headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('authToken'),
              },
            },
          }
        } />
      </Col>
    );
  }
}

export default DataUploader;
